export const _en = {
    toggleDeleted: {
        label: ""
    },
    firstRow: {
        addButton: {
            label: "Add"
        },
        modal: {
            label: "Resource category creation"
        }
    },
    secondRow: {
        addButon: {
            label: "Add"
        },
        modal: {
            label: "Code event creation"
        }
    },
    dialog: {
        new: {
            title: "New"
        },
        edit: {
            title: "Edit",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        duplicate: {
            title: "Duplicate",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        delete: {
            warningTitle: "Would you like to delete: {{item}} ?"
        }
    }
};

export const _fr = {
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    firstRow: {
        addButton: {
            label: "Catégorie de ressources"
        },
        modal: {
            label: "Ajout d'une nouvelle catégorie de ressource"
        }
    },
    secondRow: {
        addButton: {
            label: "Code évènement"
        },
        modal: {
            label: "Ajout d'un nouveau code évènement"
        }
    },
    dialog: {
        new: {
            title: "Nouveau"
        },
        edit: {
            title: "Édition d'un code évènement",
            buttons: {
                save: "Éditer",
                cancel: "Annuler"
            }
        },
        duplicate: {
            title: "Duplication d'un code évènment",
            buttons: {
                save: "Dupliquer",
                cancel: "Annuler"
            }
        },
        delete: {
            warningTitle: "Voulez vous supprimer : {{item}} ?"
        }
    }
};